import { Switch } from '@affine/component';
import type { FC } from 'react';

import * as css from './controls.css';

export interface BooleanToggleProps {
  value: boolean;
  onChange: (v: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
  'data-sl-field': string;
}

export const BooleanToggle: FC<BooleanToggleProps> = ({
  value,
  onChange,
  label,
  description,
  disabled,
  'data-sl-field': field,
}) => (
  <div
    className={css.toggleRow}
    data-sl-field={field}
    data-sl-state={value ? 'on' : 'off'}
  >
    <div className={css.toggleText}>
      <span className={css.controlLabel}>{label}</span>
      {description ? (
        <span className={css.controlDescription}>{description}</span>
      ) : null}
    </div>
    <Switch checked={value} onChange={onChange} disabled={disabled} />
  </div>
);
